import React from "react";
import Helmet from "react-helmet"

const Fonts = () => {
    return(
        <Helmet>
            <link 
                href="https://fonts.googleapis.com/css2?family=Muli:wght@400&family=Poppins:wght@400&display=swap" 
                rel="stylesheet"/>
        </Helmet>
    );
};

export default Fonts;
